(function (root) {
  'use strict';
  const schedule = [
    { start: '2026-10-01', end: '2026-10-31', until: '2026-11-01T05:00:00Z', percent: 25, cents: 2625, code: 'DDADD25OCT26' },
    { start: '2026-11-01', end: '2026-11-30', until: '2026-12-01T06:00:00Z', percent: 30, cents: 2450, code: 'DDADD30NOV26' },
    { start: '2026-12-01', end: '2026-12-31', until: '2027-01-01T06:00:00Z', percent: 40, cents: 2100, code: 'DDADD40DEC26' },
    { start: '2027-01-01', end: '2027-01-27', until: '2027-01-28T06:00:00Z', percent: 60, cents: 1400, code: 'DDADD60JAN27' }
  ];
  function rateAt(time, periods = schedule) {
    const date = new Date(time);
    if (!Number.isFinite(date.getTime())) return null;
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
    const value = name => parts.find(part => part.type === name).value;
    const day = `${value('year')}-${value('month')}-${value('day')}`;
    return periods.find(period => day >= period.start && day <= period.end) || null;
  }
  function hasDiscount(cart, allowedCode) {
    return Number(cart.total_discount) > 0 || (cart.discount_codes || []).some(discount => !allowedCode || discount.code !== allowedCode || discount.applicable !== false) ||
      (cart.cart_level_discount_applications || []).length > 0 || (cart.discount_applications || []).length > 0 ||
      cart.items.some(item => Number(item.total_discount) > 0 || Number(item.line_level_total_discount) > 0 ||
        (item.discounts || []).length > 0 || (item.line_level_discount_allocations || []).length > 0 ||
        Number(item.final_price) < Number(item.original_price));
  }
  function isDots(item, config) {
    return config.excludedProductIds.map(String).includes(String(item.product_id)) ||
      config.excludedVariantIds.map(String).includes(String(item.variant_id || item.id)) ||
      (config.excludedSkus || []).includes(String(item.sku || '')) ||
      /dippin[’'\s-]*dots/i.test(String(item.product_title || item.title || item.handle || '')) && /energy|rainbow ice|jar/i.test(String(item.product_title || item.title || item.handle || ''));
  }
  function wholesaleProperties(properties) {
    return Object.entries(properties || {}).some(([key, value]) => /wholesale|b2b/i.test(`${key} ${value}`));
  }
  function eligible(cart, product, context, config, time, allowedCode) {
    const rate = rateAt(time, config.schedule);
    if (!config.enabled || !rate || !Array.isArray(cart.items) || cart.item_count < 1) return null;
    if (context.blocked || context.country !== 'US' || cart.currency !== 'USD') return null;
    if (config.requireDiscountCodeVisibility && !Array.isArray(cart.discount_codes)) return null;
    if (hasDiscount(cart, allowedCode) || wholesaleProperties(cart.attributes)) return null;
    if (cart.items.some(item => item.selling_plan_allocation || item.selling_plan || wholesaleProperties(item.properties) || isDots(item, config))) return null;
    const variant = (product.variants || []).find(item => String(item.id) === String(config.variantId));
    if (String(product.id) !== String(config.productId) || !variant || !variant.available || Number(variant.price) !== config.baseCents || product.requires_selling_plan) return null;
    if (variant.quantity_rule && (variant.quantity_rule.min > 1 || variant.quantity_rule.increment > 1)) return null;
    return rate;
  }
  function bounded(task, timeout = 8000) {
    const controller = new AbortController();
    let timer;
    const deadline = new Promise((resolve, reject) => {
      timer = setTimeout(() => { controller.abort(); reject(new Error('Request timed out')); }, timeout);
    });
    return Promise.race([Promise.resolve().then(() => task(controller.signal)), deadline]).finally(() => clearTimeout(timer));
  }
  async function executeOffer(rawIo, config, context, shownCode, marker) {
    const io = Object.fromEntries(['read', 'apply', 'add', 'remove'].map(name => [name, value => bounded(signal => rawIo[name](value, signal), config.requestTimeoutMs || 8000)]));
    let addAttempted = false;
    let addConfirmed = false;
    try {
      const first = await io.read();
      const rate = eligible(first.cart, first.product, context, config, first.time);
      if (!rate || rate.code !== shownCode) return { state: 'stale' };
      await io.apply(rate.code);
      const prepared = await io.read();
      const saved = prepared.cart.discount_codes;
      if (!Array.isArray(saved) || saved.length !== 1 || saved[0].code !== rate.code || saved[0].applicable !== false ||
          eligible(prepared.cart, prepared.product, context, config, prepared.time, rate.code)?.code !== rate.code) return { state: 'stale', cart: prepared.cart };
      addAttempted = true;
      await io.add({ id: config.variantId, quantity: 1, properties: { _dd_cart_offer: marker } });
      addConfirmed = true;
      const final = await io.read();
      const own = final.cart.items.filter(item => item.properties && item.properties._dd_cart_offer === marker);
      const line = own[0];
      const applied = (final.cart.discount_codes || []).some(discount => String(discount.code).toUpperCase() === rate.code && discount.applicable === true);
      const variant = final.product.variants.find(item => String(item.id) === String(config.variantId));
      if (own.length !== 1 || !line || line.quantity !== 1 || line.final_line_price !== rate.cents || !applied ||
          final.cart.discount_codes.length !== 1 || final.cart.currency !== 'USD' || !variant || !variant.available || variant.price !== config.baseCents ||
          final.cart.items.some(item => item.selling_plan_allocation || item.selling_plan || wholesaleProperties(item.properties)) ||
          final.cart.items.filter(item => isDots(item, config)).reduce((sum, item) => sum + item.quantity, 0) !== 1 ||
          rateAt(final.time, config.schedule)?.code !== rate.code) return await safeRollback(io, marker, false);
      return { state: 'added', cart: final.cart };
    } catch (error) {
      if (!addAttempted) return { state: 'failed' };
      return await safeRollback(io, marker, addAttempted && !addConfirmed && !error.rejected);
    }
  }
  async function safeRollback(io, marker, absenceUncertain) {
    try {
      const latest = await io.read();
      const own = latest.cart.items.filter(item => item.properties && item.properties._dd_cart_offer === marker);
      if (own.length === 0) return { state: absenceUncertain ? 'uncertain' : 'failed', cart: latest.cart };
      if (own.length !== 1 || own[0].quantity !== 1) return { state: 'uncertain', cart: latest.cart };
      await io.remove(own[0].key);
      const checked = await io.read();
      return { state: checked.cart.items.some(item => item.properties && item.properties._dd_cart_offer === marker) ? 'uncertain' : 'failed', cart: checked.cart };
    } catch (failure) { return { state: 'uncertain' }; }
  }
  async function guarded(operation, guard, cleanup = () => {}) {
    let result = { state: 'uncertain' };
    try { guard(true, false); result = await operation(); return result; }
    catch (error) { return result; }
    finally { try { guard(result.state === 'uncertain', result.state === 'uncertain'); } finally { cleanup(); } }
  }
  const api = { schedule, rateAt, hasDiscount, isDots, eligible, executeOffer, bounded, guarded, createCheckoutGuard };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document || !root.customElements || root.customElements.get('dd-cart-offer')) return;
  let busy = false;
  let uncertain = false;
  let refreshTimer;
  const instances = new Set();
  const checkoutGuard = createCheckoutGuard();
  class DotsCartOffer extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-dd-config]').textContent);
      this.context = this.config.context;
      this.button = this.querySelector('[data-dd-add]');
      this.status = this.querySelector('[data-dd-status]');
      this.panel = this.querySelector('[data-dd-panel]');
      this.button.addEventListener('click', () => this.add());
      instances.add(this);
      this.update();

    }
    disconnectedCallback() {
      instances.delete(this);
      root.clearTimeout(this.timer);

    }
    async request(path, body, externalSignal) {
      return bounded(async signal => {
        const options = { signal: externalSignal || signal, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
        if (body) Object.assign(options, { method: 'POST', headers: { ...options.headers, 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        const response = await root.fetch(this.config.root + path, options);
        if (!response.ok) { const error = new Error('Cart request failed'); error.rejected = true; throw error; }
        const date = Date.parse(response.headers.get('Date'));
        if (!body && (!Number.isFinite(date) || Math.abs(Date.now() - date) > 300000)) throw new Error('Unverified time');
        return { data: await response.json(), time: date };
      }, this.config.requestTimeoutMs || 8000);
    }
    async read(signal) {
      const [cart, product] = await Promise.all([this.request('cart.js', null, signal), this.request(`products/${this.config.handle}.js`, null, signal)]);
      return { cart: cart.data, product: product.data, time: cart.time };
    }
    async update() {
      if (busy || uncertain || !this.isConnected || !root.navigator.locks) return;
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const data = await this.read();
        if (!this.isConnected || revision !== this.revision || busy || uncertain) return;
        const rate = eligible(data.cart, data.product, this.context, this.config, data.time);
        this.panel.hidden = !rate;
        this.button.disabled = !rate;
        if (!rate) return;
        this.shownCode = rate.code;
        root.clearTimeout(this.timer);
        this.timer = root.setTimeout(() => this.update(), Math.min(2147483647, Math.max(1000, Date.parse(rate.until) - data.time + 1000)));
        this.querySelector('[data-dd-price]').textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rate.cents / 100);
        this.querySelector('[data-dd-saving]').textContent = this.config.text.saving.replace('__PERCENT__', rate.percent);
      } catch (error) { this.panel.hidden = true; }
    }
    async add() {
      if (!root.navigator.locks) return;
      await root.navigator.locks.request('advanced-dd-cart-offer', { ifAvailable: true }, lock => lock ? this.addLocked() : undefined);
    }
    async addLocked() {
      if (busy || uncertain || this.button.disabled) return;
      busy = true;
      instances.forEach(instance => { instance.button.disabled = true; });
      this.status.textContent = this.config.text.adding;
      this.setAttribute('aria-busy', 'true');
      const result = await guarded(() => executeOffer({
        read: (unused, signal) => this.read(signal),
        add: (item, signal) => this.request('cart/add.js', { items: [item] }, signal),
        apply: (code, signal) => this.request('cart/update.js', { discount: code }, signal),
        remove: (key, signal) => this.request('cart/change.js', { id: key, quantity: 0 }, signal)
      }, this.config, this.context, this.shownCode, root.crypto.randomUUID()), (active, unknown) => checkoutGuard(active, unknown, this.config.text), () => {
        busy = false;
        this.removeAttribute('aria-busy');
      });
      uncertain = result.state === 'uncertain';
      this.status.textContent = this.config.text[result.state];
      if (result.state === 'added' || result.state === 'uncertain') this.panel.hidden = true;
      this.status.tabIndex = -1;
      this.status.focus({ preventScroll: true });
      if (result.cart) root.document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: result.cart } }));
      if (result.cart && !uncertain) root.document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: result.cart } }));
      if (root.location.pathname.replace(/\/$/, '').endsWith('/cart') && result.state === 'added') root.location.reload();
      if (!uncertain) refreshAll();
    }
  }
  function createCheckoutGuard(doc = root.document, Observer = root.MutationObserver) {
    let active = false;
    let observer;
    let notice;
    const originals = new Map();
    const selector = 'button[name="checkout"], input[type="submit"][name="checkout"], a[href^="/checkout"], .additional-checkout-buttons, .shopify-payment-button';
    function protect() {
      doc.querySelectorAll(selector).forEach(node => {
        if (!originals.has(node)) originals.set(node, { inert: node.inert, disabled: node.disabled, aria: node.getAttribute('aria-disabled') });
        node.inert = true;
        if ('disabled' in node) node.disabled = true;
        node.setAttribute('aria-disabled', 'true');
      });
    }
    function prevent(event) {
      if (!active) return;
      const target = event.target;
      const checkout = event.type === 'submit' ? target.matches('form') && (target.querySelector('[name="checkout"]') || target.id === 'mini-cart-form') : target.closest?.(selector);
      if (checkout) { event.preventDefault(); event.stopImmediatePropagation(); }
    }
    doc.addEventListener('click', prevent, true);
    doc.addEventListener('submit', prevent, true);
    return (enabled, unknown, text) => {
      active = enabled;
      if (enabled) {
        protect();
        if (!observer) { observer = new Observer(protect); observer.observe(doc.body, { childList: true, subtree: true }); }
        if (!notice) {
          notice = doc.createElement('div');
          notice.className = 'dd-cart-offer__guard';
          notice.setAttribute('role', 'alert');
          const message = doc.createElement('p');
          const refresh = doc.createElement('button');
          refresh.type = 'button';
          refresh.addEventListener('click', () => root.location.reload());
          notice.append(message, refresh);
          doc.body.append(notice);
        }
        notice.firstElementChild.textContent = unknown ? text.uncertain : text.adding;
        notice.lastElementChild.textContent = text.refresh;
        notice.lastElementChild.hidden = !unknown;
      } else {
        observer?.disconnect(); observer = null;
        originals.forEach((value, node) => {
          node.inert = value.inert;
          if ('disabled' in node) node.disabled = value.disabled;
          if (value.aria === null) node.removeAttribute('aria-disabled'); else node.setAttribute('aria-disabled', value.aria);
        });
        originals.clear();
        notice?.remove(); notice = null;
      }
    };
  }
  function refreshAll() {
    root.clearTimeout(refreshTimer);
    refreshTimer = root.setTimeout(() => instances.forEach(instance => instance.update()), 120);
  }
  root.customElements.define('dd-cart-offer', DotsCartOffer);
  ['cart:updated', 'cart:refresh', 'shopify:section:load', 'pageshow', 'focus'].forEach(name => root.addEventListener(name, refreshAll));
})(typeof window !== 'undefined' ? window : globalThis);
